/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ConnectionStats = {
  documentCount: number;
  pageCount: number;
};

/** @internal */
export const ConnectionStats$inboundSchema: z.ZodType<
  ConnectionStats,
  z.ZodTypeDef,
  unknown
> = z.object({
  document_count: z.number().int(),
  page_count: z.number(),
}).transform((v) => {
  return remap$(v, {
    "document_count": "documentCount",
    "page_count": "pageCount",
  });
});
/** @internal */
export type ConnectionStats$Outbound = {
  document_count: number;
  page_count: number;
};

/** @internal */
export const ConnectionStats$outboundSchema: z.ZodType<
  ConnectionStats$Outbound,
  z.ZodTypeDef,
  ConnectionStats
> = z.object({
  documentCount: z.number().int(),
  pageCount: z.number(),
}).transform((v) => {
  return remap$(v, {
    documentCount: "document_count",
    pageCount: "page_count",
  });
});

export function connectionStatsToJSON(
  connectionStats: ConnectionStats,
): string {
  return JSON.stringify(ConnectionStats$outboundSchema.parse(connectionStats));
}
export function connectionStatsFromJSON(
  jsonString: string,
): SafeParseResult<ConnectionStats, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConnectionStats$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConnectionStats' from JSON`,
  );
}
